import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const actionsFilterMixin = {
  data() {
    return {
      filteredActions: [],
    };
  },
  watch: {
    actions: {
      immediate: true,
      handler() {
        this.filteredActions = this.actions;
      },
    },
  },
  methods: {
    actionsFilterMethod(query) {
      this.filteredActions = searchWithDiacritics(query, this.actions, ['name']);
    },
    handleActionsVisibleChange() {
      setTimeout(() => {
        this.filteredActions = this.actions;
      }, 50);
    },
  },
};
